import React from 'react';
import CookieBanner from './CookieBanner';

const Footer = () => {
  return <div style={{ width: '100%' }}>
    <div style={{ backgroundColor: 'white', paddingLeft: 24, paddingRight: 24, paddingTop: 8, paddingBottom: 8, display: 'flex', justifyContent: 'center' }}>
      <span style={{ color: '#333', fontSize: 14, fontFamily: 'Montserrat', fontWeight: 400, textAlign: 'center' }}>Global Guardians Management Ltd. Sopers House, Sopers Road, Cuffley, Potters Bar EN6 4RY.  Company Registration number: 7676554</span>
      {/* <span style={{ color: '#333', fontSize: 14, fontFamily: 'Montserrat', fontWeight: 400, textAlign: 'center' }}>Copyright 2025 Global Guardians Management Ltd. All rights reserved</span> */}
    </div>
  </div>;
};

export default Footer; 